import {
  Runtime,
  useContentModule,
  useSiteInfo,
} from '@silvertours/front-entities';
import { TrustWrapper } from './TrustSeals.styles';
import { Trustpilot } from './TrustElements/Trustpilot';

type TrustSealsProps = {
  hasStageAbove?: boolean;
  isPlainTemplate?: boolean;
};

const TrustSeals = ({
  hasStageAbove = true,
  isPlainTemplate = false,
}: TrustSealsProps) => {
  const { featureToggles } = useSiteInfo();
  const { language } = Runtime.useLocale();

  const { getTrustpilotData } = useContentModule();
  const trustpilotProps = getTrustpilotData();

  if (
    (language !== 'de' && language !== 'fr') ||
    !featureToggles.trustElementOnStageImage ||
    !trustpilotProps
  ) {
    return null;
  }

  return (
    <TrustWrapper
      isPlainTemplate={isPlainTemplate}
      hasStageAbove={hasStageAbove}
    >
      <Trustpilot {...trustpilotProps} />
    </TrustWrapper>
  );
};

export { TrustSeals };
